import { render, staticRenderFns } from "./fccDocumentosNecessarios.vue?vue&type=template&id=26028810"
import script from "./fccDocumentosNecessarios.vue?vue&type=script&lang=js"
export * from "./fccDocumentosNecessarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports